import Image from "next/image";
import React from "react";

const CloseButton = ({ CloseAll }) => {
  return (
    <div type="button" className="flex justify-end w-full p-3">
      <button onClick={CloseAll}>
        <Image src="/icons/close.svg" alt="close" width={14} height={14} />
      </button>
    </div>
  );
};

export default CloseButton;
